export const IS_PRODUCTION_ENV = process.env.REACT_APP_ENV === 'production';
